﻿// © Microsoft Corporation. All rights reserved.

// Defines constants used in telemetry beacons
//  <summary>
//      This is a auto-generated file using MSNTelemetryCodeGen (https://microsoft.visualstudio.com/DefaultCollection/Universal%20Store/_git/MSN.Tool.Telemetry?path=%2FMSNTelemetryDimensionsCodeGen/)
//  </summary>

//  <summary>
//      This is a auto-generated file using MSNTelemetryDimensionsCodeGen (https://microsoft.visualstudio.com/DefaultCollection/Universal%20Store/_git/MSN.Tool.Telemetry?path=%2FMSNTelemetryDimensionsCodeGen/)
//  </summary>
var PageNamePageTypeMappingList = {};
var TelemetryTypeContentTypeMappingList = {};
var TelemetryTypeBehaviorTypeMappingList = {};

/// <summary> Telemetry Product </summary>
var TelemetryProduct = {
    Spartan: "spartan",
    Prime: "prime",
    PrimeMobile: "prime_mobile",
    IEext: "ieext",
    SpartanMobile: "spartan_mobile",
    TabbedShell: "tabbedshell",
    ChromeExt: "chromeext",
    Downlevel: "downlevel",
    Xbox: "xbox"
};

/// <summary> Telemetry PageType </summary>
var TelemetryPageType = {
    Unspecified: "unspecified",
    DHP: "dhp",
    NTP: "ntp",
    HomePage: "hp",
    VerticalHomePage: "verthp",
    StructuredDataPage: "data",
    SectionFront: "secfront",
    SiteSearch: "sitesearch",
    Article: "article",
    Gallery: "gallery",
    Video: "video",
    SubjectSection: "subjectsec",
    CustomColumn: "custcol"
};

// TODO: (nubenja) Remove this once all partners moves from TelemetryType to ContentType and ContentAction
/// <summary> Telemetry Type </summary>
var TelemetryType = {
    Undefined: 0,
    Header: 1,
    Footer: 2,
    TopNavBar: 3,
    NavBar: 4,
    DropDown: 5,
    Section: 6,
    Carousel: 7,
    Module: 8,
    SearchBox: 9,
    InputBox: 10,
    ActionButton: 11,
    Interaction: 12,
    Headline: 13,
    Navigation: 14,
    Entity: 15,
    StructuredData: 16,
    AppStore: 17,
    AppLaunch: 18,
    CmsPromotions: 19,
    MicrosoftWebStore: 20,
    XboxStore: 21,
    OfficeStore: 22,
    AppInstall: 23,
    PartnerLinks: 24,
    SponsoredContent: 25,
    Follow: 26,
    Unfollow: 27,
    MoreFrom: 28,
    Topic: 29,
    Provider: 30,
    Spotlight: 33,
    ShareClose: 36,
    Share: 37,
    Like: 38,
    Dislike: 39,
    Unlike: 40,
    Undislike: 41,
    Mute: 42,
    Unmute: 43,
    MuteCancel: 44,
    Manage: 45,
    NewStories: 46,
    AutoSuggest: 47,
    BingCard: 48,
    Tile: 49,
    TrendingNews: 50,
    AllCoverage: 51,
    Report: 52,
    AdChoice: 53,
    Hide: 55,
    Unhide: 56
};

/// <summary> Telemetry Content Type </summary>
var TelemetryContentType = {
    Undefined: 0,
    App: 1,
    Article: 2,
    Feed: 3,
    Gallery: 4,
    AppStorePromo: 5,
    Settings: 6,
    SponsoredContent: 7,
    StructuredDataCard: 8,
    Video: 9,
    Webview: 10,
    Activity: 11,
    Win32: 12,
    OfficeDocument: 13,
    LocalFile: 14,
    CardAction: 15
};

/// <summary> Telemetry Behavior Type </summary>
const TelemetryBehaviorType = {
    Undefined: 0,
    Navigate: 1,
    ContextMenu: 2,
    Pin: 3,
    Unpin: 4,
    Rearrange: 5,
    Remove: 6,
    Add: 7,
    Open: 8,
    View: 9,
    Follow: 10,
    Unfollow: 11,
    More: 12,
    Close: 13,
    Share: 14,
    Like: 15,
    Dislike: 16,
    Unlike: 17,
    Undislike: 18,
    Mute: 19,
    Unmute: 20,
    Cancel: 21,
    Launch: 22,
    Install: 23,
    Manage: 24,
    Show: 25,
    MuteCancel: 26,
    Save: 27,
    Hide: 28,
    Unhide: 29,
    Customize: 30
};

/// <summary> Telemetry ContentPlacedBySource </summary>
var ContentPlacedBySource = {
    Editor: 0,
    PersonalizationAlgo: 1,
    Bing: 2,
    Taboola: 3,
    Outbrain: 4,
    AutoCuration: 5,
    User: 6,
    AppNexus: 7,
    OtherSponconProvider: 8
};

/// <summary> Telemetry Page Configuration </summary>
var TelemetryPageConfiguration = {
    NoContent: 0,
    OneBox: 1,
    TopSites: 2,
    Suggested: 4,
    ContentFeed: 8,
    WinFre: 16,
    StripeLayout: 1024
};

/// <summary> Telemetry Partner Namespace </summary>
var TelemetryPartnerNamespace = {
    MMX: "m",
    Shell: "s",
    Edge: "e",
    Office: "o",
    Activity: "a",
    Cortana: "c"
};

/// <summary> Telemetry PageName </summary>
var TelemetryPageName = {
    StartPage: telemetryPageName("startpage", TelemetryPageType.HomePage),
    // @ts-ignore
    DefaultPage: telemetryPageName("default"),
    // @ts-ignore
    EduPage: telemetryPageName("edu"),
    // @ts-ignore
    ChildModePage: telemetryPageName("child"),
    // @ts-ignore
    Office: telemetryPageName("office"),
    // @ts-ignore
    Feed: telemetryPageName("xfeed"),
    // @ts-ignore
    Discover: telemetryPageName("discover"),
    // @ts-ignore
    MyInterests: telemetryPageName("myinterests"),
    // @ts-ignore
    CombinedInterests: telemetryPageName("cinterests"),
    ArticlePageNames:
    {
        Article: telemetryPageName("article", TelemetryPageType.Article),
        ArticleVNext: telemetryPageName("articlevnext", TelemetryPageType.Article),
        ArticleListicle: telemetryPageName("article_listicle", TelemetryPageType.Article),
        ArticleCollection: telemetryPageName("articlecollection", TelemetryPageType.Article),
        ArticleFullScreen: telemetryPageName("articlefullscreen", TelemetryPageType.Article),
        FlexibleArticle: telemetryPageName("articleflex", TelemetryPageType.Article),
        FlexibleArticleMobile: telemetryPageName("articleflexmobile", TelemetryPageType.Article),
        ArticleGalleryFullScreen: telemetryPageName("article_galleryfs", TelemetryPageType.Article)
    },
    GalleryPageNames:
    {
        Gallery: telemetryPageName("gallery", TelemetryPageType.Gallery),
        GalleryVNext: telemetryPageName("galleryvnext", TelemetryPageType.Gallery),
        GalleryFullScreen: telemetryPageName("gallery_fullscreen", TelemetryPageType.Gallery),
        GalleryClassic: telemetryPageName("gallery_classic", TelemetryPageType.Gallery),
        GalleryClassicFullScreen: telemetryPageName("gallery_classicfs", TelemetryPageType.Gallery),
        GallerySearch: telemetryPageName("gallery_search", TelemetryPageType.Gallery),
        GallerySearchFullScreen: telemetryPageName("gallery_searchfs", TelemetryPageType.Gallery),
        FlexibleGallery: telemetryPageName("galleryflex", TelemetryPageType.Gallery),
        FlexibleGalleryMobile: telemetryPageName("galleryflexmobile", TelemetryPageType.Gallery),
        GalleryImmersive: telemetryPageName("gallery_immersive", TelemetryPageType.Gallery),
        GalleryImmersiveFullScreen: telemetryPageName("gallery_immersivefs", TelemetryPageType.Gallery),
        GallerySponsored: telemetryPageName("gallery_sponsor", TelemetryPageType.Gallery),
        GallerySponsoredFullScreen: telemetryPageName("gallery_sponsorfs", TelemetryPageType.Gallery),
        GalleryInline: telemetryPageName("gallery_inline", TelemetryPageType.Gallery)
    },
    VideoPageNames:
    {
        ChannelPlayerPage: telemetryPageName("channelplayerpage", TelemetryPageType.Video),
        PartnerPlayerPage: telemetryPageName("partnerplayerpage", TelemetryPageType.Video)
    },
    VerticalHomePageNames:
    {
        HomePage: telemetryPageName("homepage", TelemetryPageType.VerticalHomePage),
        HomePageToday: telemetryPageName("homepage-today", TelemetryPageType.VerticalHomePage)
    },
    StructuredDataPageNames:
    {
        Gamecenter: telemetryPageName("gamecenter", TelemetryPageType.StructuredDataPage),
        Schedule: telemetryPageName("schedule", TelemetryPageType.StructuredDataPage),
        Scores: telemetryPageName("scores", TelemetryPageType.StructuredDataPage),
        Stocksummary: telemetryPageName("stocksummary", TelemetryPageType.StructuredDataPage),
        Stocksummaryoneriver: telemetryPageName("stocksummaryoneriver", TelemetryPageType.StructuredDataPage),
        Weatherxplatmaps: telemetryPageName("weatherxplatmaps", TelemetryPageType.StructuredDataPage),
        Standings: telemetryPageName("standings", TelemetryPageType.StructuredDataPage),
        Markets: telemetryPageName("markets", TelemetryPageType.StructuredDataPage),
        Watchlistpage: telemetryPageName("watchlistpage", TelemetryPageType.StructuredDataPage),
        Data_modelpage: telemetryPageName("data_modelpage", TelemetryPageType.StructuredDataPage),
        Immersivechartspage: telemetryPageName("immersivechartspage", TelemetryPageType.StructuredDataPage),
        Currencies: telemetryPageName("currencies", TelemetryPageType.StructuredDataPage),
        Indexdetailspage: telemetryPageName("indexdetailspage", TelemetryPageType.StructuredDataPage),
        Data_makepage: telemetryPageName("data_makepage", TelemetryPageType.StructuredDataPage),
        Weatherfullscreenmaps: telemetryPageName("weatherfullscreenmaps", TelemetryPageType.StructuredDataPage),
        Weatherthresholdmaps: telemetryPageName("weatherthresholdmaps", TelemetryPageType.StructuredDataPage),
        Stockanalysisdetails: telemetryPageName("stockanalysisdetails", TelemetryPageType.StructuredDataPage),
        Data_yearoverview: telemetryPageName("data_yearoverview", TelemetryPageType.StructuredDataPage),
        Data_segmenthub: telemetryPageName("data_segmenthub", TelemetryPageType.StructuredDataPage),
        Weathermaps: telemetryPageName("weathermaps", TelemetryPageType.StructuredDataPage),
        Playerstats: telemetryPageName("playerstats", TelemetryPageType.StructuredDataPage),
        Funddetailspage: telemetryPageName("funddetailspage", TelemetryPageType.StructuredDataPage),
        Exercisedetails: telemetryPageName("exercisedetails", TelemetryPageType.StructuredDataPage),
        Teams: telemetryPageName("teams", TelemetryPageType.StructuredDataPage),
        Etfdetailspage: telemetryPageName("etfdetailspage", TelemetryPageType.StructuredDataPage),
        Binganswermaps: telemetryPageName("binganswermaps", TelemetryPageType.StructuredDataPage),
        Workoutdetails: telemetryPageName("workoutdetails", TelemetryPageType.StructuredDataPage),
        Competitionstats: telemetryPageName("competitionstats", TelemetryPageType.StructuredDataPage),
        Polls: telemetryPageName("polls", TelemetryPageType.StructuredDataPage),
        Data_photos: telemetryPageName("data_photos", TelemetryPageType.StructuredDataPage),
        Videocategorylistpage: telemetryPageName("videocategorylistpage", TelemetryPageType.StructuredDataPage),
        Stockfinancialsdetails: telemetryPageName("stockfinancialsdetails", TelemetryPageType.StructuredDataPage),
        Commoditydetailspage: telemetryPageName("commoditydetailspage", TelemetryPageType.StructuredDataPage),
        Data_yearoverview_trim: telemetryPageName("data_yearoverview_trim", TelemetryPageType.StructuredDataPage),
        Worldwidepage: telemetryPageName("worldwidepage", TelemetryPageType.StructuredDataPage),
        Data_photos_trim: telemetryPageName("data_photos_trim", TelemetryPageType.StructuredDataPage),
        Stockcompanydetails: telemetryPageName("stockcompanydetails", TelemetryPageType.StructuredDataPage),
        Retirementplanner: telemetryPageName("retirementplanner", TelemetryPageType.StructuredDataPage),
        Livecoverage: telemetryPageName("livecoverage", TelemetryPageType.StructuredDataPage),
        Teamroster: telemetryPageName("teamroster", TelemetryPageType.StructuredDataPage),
        Stockhistorydetails: telemetryPageName("stockhistorydetails", TelemetryPageType.StructuredDataPage),
        Filterresultspage: telemetryPageName("filterresultspage", TelemetryPageType.StructuredDataPage),
        Data_carcompare: telemetryPageName("data_carcompare", TelemetryPageType.StructuredDataPage),
        Stockownershipdetails: telemetryPageName("stockownershipdetails", TelemetryPageType.StructuredDataPage),
        Driverstandings: telemetryPageName("driverstandings", TelemetryPageType.StructuredDataPage),
        Timevalueofmoney: telemetryPageName("timevalueofmoney", TelemetryPageType.StructuredDataPage),
        Savingscalculator: telemetryPageName("savingscalculator", TelemetryPageType.StructuredDataPage),
        Iccmatches: telemetryPageName("iccmatches", TelemetryPageType.StructuredDataPage),
        Other_flightsearchresult: telemetryPageName("other_flightsearchresult", TelemetryPageType.StructuredDataPage),
        Stockrelateddetails: telemetryPageName("stockrelateddetails", TelemetryPageType.StructuredDataPage),
        Data_specs_trim: telemetryPageName("data_specs_trim", TelemetryPageType.StructuredDataPage),
        Stockoptionsdetails: telemetryPageName("stockoptionsdetails", TelemetryPageType.StructuredDataPage),
        HomepageAlerts: telemetryPageName("homepage-alerts", TelemetryPageType.StructuredDataPage),
        HomepageRecordsandAverages: telemetryPageName("homepage-recordsandaverages", TelemetryPageType.StructuredDataPage),
        HomepageWeatherTraffic: telemetryPageName("homepage-weathertraffic", TelemetryPageType.StructuredDataPage),
        Data_specs: telemetryPageName("data_specs", TelemetryPageType.StructuredDataPage),
        Data_pricing: telemetryPageName("data_pricing", TelemetryPageType.StructuredDataPage),
        Mortgagecalculator: telemetryPageName("mortgagecalculator", TelemetryPageType.StructuredDataPage),
        Data_performance_trim: telemetryPageName("data_performance_trim", TelemetryPageType.StructuredDataPage),
        Theatershowtimes: telemetryPageName("theatershowtimes", TelemetryPageType.StructuredDataPage),
        Data_pricing_trim: telemetryPageName("data_pricing_trim", TelemetryPageType.StructuredDataPage),
        Data_photosInterior: telemetryPageName("data_photos-interior", TelemetryPageType.StructuredDataPage),
        Indexdetailsanalysispage: telemetryPageName("indexdetailsanalysispage", TelemetryPageType.StructuredDataPage),
        Data_photosInterior_trim: telemetryPageName("data_photos-interior_trim", TelemetryPageType.StructuredDataPage),
        Data_photosColors: telemetryPageName("data_photos-colors", TelemetryPageType.StructuredDataPage),
        Data_carReviews_trim: telemetryPageName("data_car-reviews_trim", TelemetryPageType.StructuredDataPage),
        Data_carReviews: telemetryPageName("data_car-reviews", TelemetryPageType.StructuredDataPage),
        Racecalendar: telemetryPageName("racecalendar", TelemetryPageType.StructuredDataPage),
        Teamstandings: telemetryPageName("teamstandings", TelemetryPageType.StructuredDataPage),
        Data_photosColors_trim: telemetryPageName("data_photos-colors_trim", TelemetryPageType.StructuredDataPage),
        Stockdetails: telemetryPageName("stockdetails", TelemetryPageType.StructuredDataPage),
        Data_interiorFeatures_trim: telemetryPageName("data_interior-features_trim", TelemetryPageType.StructuredDataPage),
        Data_exteriorFeatures_trim: telemetryPageName("data_exterior-features_trim", TelemetryPageType.StructuredDataPage),
        Calendar: telemetryPageName("calendar", TelemetryPageType.StructuredDataPage),
        TeamStats: telemetryPageName("teamstats", TelemetryPageType.StructuredDataPage),
        Movieshowtimes: telemetryPageName("movieshowtimes", TelemetryPageType.StructuredDataPage),
        Drafts: telemetryPageName("drafts", TelemetryPageType.StructuredDataPage),
        Data_technologyFeatures_trim: telemetryPageName("data_technology-features_trim", TelemetryPageType.StructuredDataPage),
        Data_workoutdetails_collection: telemetryPageName("data_workoutdetails_collection", TelemetryPageType.StructuredDataPage),
        Data_photosExterior: telemetryPageName("data_photos-exterior", TelemetryPageType.StructuredDataPage),
        Data_photosExterior_trim: telemetryPageName("data_photos-exterior_trim", TelemetryPageType.StructuredDataPage),
        Data_photos360Interior: telemetryPageName("data_photos-360-interior", TelemetryPageType.StructuredDataPage),
        Immersivechartsmarketspage: telemetryPageName("immersivechartsmarketspage", TelemetryPageType.StructuredDataPage),
        Returnoninvestment: telemetryPageName("returnoninvestment", TelemetryPageType.StructuredDataPage),
        Indexdetailsrelatedpage: telemetryPageName("indexdetailsrelatedpage", TelemetryPageType.StructuredDataPage),
        Gonepage: telemetryPageName("gonepage", TelemetryPageType.StructuredDataPage),
        Data_compare: telemetryPageName("data_compare", TelemetryPageType.StructuredDataPage),
        Data_compare_trim: telemetryPageName("data_compare_trim", TelemetryPageType.StructuredDataPage),
        Data_options_trim: telemetryPageName("data_options_trim", TelemetryPageType.StructuredDataPage),
        Entitiespage: telemetryPageName("entitiespage", TelemetryPageType.StructuredDataPage),
        Workoutdetailsprint: telemetryPageName("workoutdetailsprint", TelemetryPageType.StructuredDataPage),
        Data_photos360Exterior: telemetryPageName("data_photos-360-exterior", TelemetryPageType.StructuredDataPage),
        HomepageDatacarfinder: telemetryPageName("homepage-datacarfinder", TelemetryPageType.StructuredDataPage),
        Data_photos360Interior_trim: telemetryPageName("data_photos-360-interior_trim", TelemetryPageType.StructuredDataPage),
        Data_skeleton: telemetryPageName("data_skeleton", TelemetryPageType.StructuredDataPage),
        Mortgagerates: telemetryPageName("mortgagerates", TelemetryPageType.StructuredDataPage),
        Brackets: telemetryPageName("brackets", TelemetryPageType.StructuredDataPage),
        Data_photos360Exterior_trim: telemetryPageName("data_photos-360-exterior_trim", TelemetryPageType.StructuredDataPage),
        Data_photocompare: telemetryPageName("data_photocompare", TelemetryPageType.StructuredDataPage),
        HomepageWeather10day: telemetryPageName("homepage-weather10day", TelemetryPageType.StructuredDataPage),
        Data_performance: telemetryPageName("data_performance", TelemetryPageType.StructuredDataPage),
        HomepageWeatherextendedforecast: telemetryPageName("homepage-weatherextendedforecast", TelemetryPageType.StructuredDataPage),
        Savings: telemetryPageName("savings", TelemetryPageType.StructuredDataPage),
        Data_exteriorFeatures: telemetryPageName("data_exterior-features", TelemetryPageType.StructuredDataPage),
        Data_interiorFeatures: telemetryPageName("data_interior-features", TelemetryPageType.StructuredDataPage),
        Data_options: telemetryPageName("data_options", TelemetryPageType.StructuredDataPage),
        Travelgonepage: telemetryPageName("travelgonepage", TelemetryPageType.StructuredDataPage),
        Recipe: telemetryPageName("recipe", TelemetryPageType.StructuredDataPage),
        Getportfoliodatapage: telemetryPageName("getportfoliodatapage", TelemetryPageType.StructuredDataPage),
        Brokercenterpage: telemetryPageName("brokercenterpage", TelemetryPageType.StructuredDataPage),
        Data_technologyFeatures: telemetryPageName("data_technology-features", TelemetryPageType.StructuredDataPage),
        Tvlistings: telemetryPageName("tvlistings", TelemetryPageType.StructuredDataPage),
        Ownerstandings: telemetryPageName("ownerstandings", TelemetryPageType.StructuredDataPage),
        Entitydetailspage: telemetryPageName("entitydetailspage", TelemetryPageType.StructuredDataPage),
        Creditcards: telemetryPageName("creditcards", TelemetryPageType.StructuredDataPage),
        Cmssitemap: telemetryPageName("cmssitemap", TelemetryPageType.StructuredDataPage),
        Externalnativeadpage: telemetryPageName("externalnativeadpage", TelemetryPageType.StructuredDataPage),
        Autoloans: telemetryPageName("autoloans", TelemetryPageType.StructuredDataPage),
        Externalcontent: telemetryPageName("externalcontent", TelemetryPageType.StructuredDataPage),
        Htmlsitemap: telemetryPageName("htmlsitemap", TelemetryPageType.StructuredDataPage)
        },
    CustomColumnPageNames:
    {
        TrendingTopics: telemetryPageName("topic_tt", TelemetryPageType.CustomColumn),
        GlobalSettingsPage: telemetryPageName("globalsettingspage", TelemetryPageType.CustomColumn),
        MyTopics: telemetryPageName("mytopics", TelemetryPageType.CustomColumn),
        WeatherPlaces: telemetryPageName("weatherplaces", TelemetryPageType.CustomColumn),
        MyFavorites: telemetryPageName("myfavorites", TelemetryPageType.CustomColumn),
        TopicResult: telemetryPageName("topicresult", TelemetryPageType.CustomColumn),
        Collections: telemetryPageName("collections", TelemetryPageType.CustomColumn),
        Rouxbe: telemetryPageName("rouxbe", TelemetryPageType.CustomColumn),
        ShoppingList: telemetryPageName("shopping list", TelemetryPageType.CustomColumn),
        MyHealthReportsPage: telemetryPageName("myhealthreportspage", TelemetryPageType.CustomColumn),
        Error404page: telemetryPageName("error404page", TelemetryPageType.CustomColumn),
        AppsPromotion: telemetryPageName("appspromotion", TelemetryPageType.CustomColumn),
        Error500page: telemetryPageName("error500page", TelemetryPageType.CustomColumn),
        DietTrackerPreSigninPage: telemetryPageName("diettrackerpresigninpage", TelemetryPageType.CustomColumn),
        ExerciseTrackerPreSigninPage: telemetryPageName("exercisetrackerpresigninpage", TelemetryPageType.CustomColumn),
        WebSlicePage: telemetryPageName("other_webslice", TelemetryPageType.CustomColumn),
        Error200Page: telemetryPageName("error200page", TelemetryPageType.CustomColumn),
        AboutUsPage: telemetryPageName("aboutus", TelemetryPageType.CustomColumn),
        UnSupport: telemetryPageName("unsupport", TelemetryPageType.CustomColumn),
        Disclaimer: telemetryPageName("disclaimer", TelemetryPageType.CustomColumn),
        TermsOfService: telemetryPageName("termsofservice", TelemetryPageType.CustomColumn),
        SevereWeather: telemetryPageName("severeweather", TelemetryPageType.CustomColumn)
    },
    SubjectSectionPageNames:
    {
        TeamhomePage: telemetryPageName("teamhome", TelemetryPageType.SubjectSection),
        PlayerPage: telemetryPageName("player", TelemetryPageType.SubjectSection),
        MarketMoversPage: telemetryPageName("marketmovers", TelemetryPageType.SubjectSection),
        CommoditiesPage: telemetryPageName("commoditiespage", TelemetryPageType.SubjectSection),
        ChefPage: telemetryPageName("chef", TelemetryPageType.SubjectSection),
        NutritionIndexPage: telemetryPageName("nutritionindex", TelemetryPageType.SubjectSection),
        FinanceTechnologyPage: telemetryPageName("finance-technologypage", TelemetryPageType.SubjectSection),
        MedicalindexPage: telemetryPageName("medicalindex", TelemetryPageType.SubjectSection)
    },
    SiteSearchPageNames:
    {
        SearchResultsPage: telemetryPageName("searchresultspage", TelemetryPageType.SiteSearch),
        VideoSearchResultsPage: telemetryPageName("videosearchresultspage", TelemetryPageType.SiteSearch),
        PartnerVideolistPage: telemetryPageName("partnervideolistpage", TelemetryPageType.SiteSearch),
        HomepageBingserpIframepage: telemetryPageName("homepage-bingserpiframepage", TelemetryPageType.SiteSearch),
        SitesearchSitesearch: telemetryPageName("sitesearch_sitesearch", TelemetryPageType.SiteSearch),
        SearchResults: telemetryPageName("search results", TelemetryPageType.SiteSearch),
        SerpPage: telemetryPageName("serppage", TelemetryPageType.SiteSearch),
        FindaMoviePage: telemetryPageName("findamoviepage", TelemetryPageType.SiteSearch)
    },
    SectionFrontPageNames:
    {
        Competitionhub: telemetryPageName("competitionhub", TelemetryPageType.SectionFront),
        Local: telemetryPageName("local", TelemetryPageType.SectionFront),
        Stockscreener: telemetryPageName("stockscreener", TelemetryPageType.SectionFront),
        Toolslandingpage: telemetryPageName("toolslandingpage", TelemetryPageType.SectionFront),
        Showtimes: telemetryPageName("showtimes", TelemetryPageType.SectionFront),
        FinanceRealEstatepage: telemetryPageName("finance-real-estatepage", TelemetryPageType.SectionFront),
        CookingSchool: telemetryPageName("cooking school", TelemetryPageType.SectionFront),
        Allcompetitions: telemetryPageName("allcompetitions", TelemetryPageType.SectionFront),
        Newspage: telemetryPageName("newspage", TelemetryPageType.SectionFront),
        CocktailHub: telemetryPageName("cocktail hub", TelemetryPageType.SectionFront),
        Travelflightsearchhubpage: telemetryPageName("travelflightsearchhubpage", TelemetryPageType.SectionFront),
        Hotelshubpage: telemetryPageName("hotelshubpage", TelemetryPageType.SectionFront),
        WineHub: telemetryPageName("wine hub", TelemetryPageType.SectionFront),
        ChefHub: telemetryPageName("chef hub", TelemetryPageType.SectionFront),
        Travelflightstatushubpage: telemetryPageName("travelflightstatushubpage", TelemetryPageType.SectionFront),
        HomepageCompetitionhub: telemetryPageName("homepage-competitionhub", TelemetryPageType.SectionFront),
        Editorial: telemetryPageName("editorial", TelemetryPageType.SectionFront),
        SecfrontHotel: telemetryPageName("secfront_hotel", TelemetryPageType.SectionFront),
        SecfrontTNews: telemetryPageName("secfront_tnews", TelemetryPageType.SectionFront)
    }
};

/// <summary> Telemetry PageMode </summary>
var TelemetryPageMode = {
    Default: 0,
    Trial: 1,
    Subscription: 2
};

/// <summary> Telemetry Page Pivot </summary>
var TelemetryPagePivot = {
    Undefined: "undefined",
    Office: "office",
    Apps: "apps",
    News: "news",
    Timeline: "timeline",
    StartMenu: "startmenu"
};

/// <summary> Telemetry User Id Type </summary>
var TelemetryUserType = {
    Aad: "aad",
    Msa: "msa",
    MsaKids: "msa-kids",
    Local: "local"
};

const TelemetryActionType = {
    Click: "click",
    Hover: "mouseenter",
    Submit: "submit",
    View: "view",
    RightClick: "rightclick"
};

export var telemetryDataTypes = {
    TelemetryProduct: TelemetryProduct,
    TelemetryPageType: TelemetryPageType,
    TelemetryType: TelemetryType,
    TelemetryContentType: TelemetryContentType,
    TelemetryBehaviorType: TelemetryBehaviorType,
    ContentPlacedBySource: ContentPlacedBySource,
    TelemetryPageConfiguration: TelemetryPageConfiguration,
    TelemetryPageName: TelemetryPageName,
    TelemetryPageMode: TelemetryPageMode,
    TelemetryPagePivot: TelemetryPagePivot,
    TelemetryPartnerNamespace: TelemetryPartnerNamespace,
    TelemetryUserType: TelemetryUserType,
    getTelemetryContentType: getTelemetryContentType,
    getTelemetryPageInfo: getTelemetryPageInfo,
    validateTelemetryDataType: validateTelemetryDataType,
    getTelemetryBehavior: getTelemetryBehavior,
    TelemetryActionType: TelemetryActionType
};

/// <summary>
/// This function gets the telemetry page info object from the given pageName string.
/// </summary>
/// <param name="pageName" type="string">PageName string</param>
/// <return>The Telemetry Page Name object</return>
function getTelemetryPageInfo(pageName) {
    if (pageName && PageNamePageTypeMappingList) {
        pageName = pageName.toLowerCase();
        if (PageNamePageTypeMappingList[pageName] !== undefined) {
            return PageNamePageTypeMappingList[pageName];
        }
    }

    return null;
}

/// <summary>
/// This function validates and returns the telemetry data type from the given string of the data type.
/// </summary>
/// <param name="dataType" type="string">DataType enum e.g. telemetryDataType.TelemetryPageType</param>
/// <param name="value" type="string">value of the type to validate</param>
/// <return>The Telemetry Page type</return>
function validateTelemetryDataType(type, value) {
    if (type && value) {
        for (var prop in type) {
            if (type.hasOwnProperty(prop)) {
                if ((typeof value == "string" && type[prop] === value.toLowerCase()) ||
                    type[prop] === value) {
                    return type[prop];
                }
            }
        }
    }

    return null;
}

/// <summary>
/// Private class to define the telemetry Page Name. This class is purposefully not exposed to public.
/// Public should use getTelemetryPageName to get the telemetrypagename object from the given pagename string.
/// All the telemetry page names should be defined as part of this javascript file.
/// </summary>
/// <param name="pageName" type="string">PageName string</param>
/// <param name="pageType" type="TelemetryPageType">PageType should be of type TelemetryPageType</param>
/// <return>The Telemetry Page Name object</return>
function telemetryPageName(pageName, pageType) {
    if (pageName) {
        var name = pageName.toLowerCase();
        var pType = pageType || TelemetryPageType.Unspecified;
        var telemetryPageNameObject = { PageName: name, PageType: pType };
        PageNamePageTypeMappingList[name] = telemetryPageNameObject;

        return telemetryPageNameObject;
    }

    return null;
}

/// <summary>
/// This function gets the telemetry contentType from the given telemetryType.
/// </summary>
/// <param name="telemetryType" type="integer">TelemetryType enum value</param>
/// <return>ContentType enum.</return>
function getTelemetryContentType(telemetryType) {
    if (TelemetryTypeContentTypeMappingList[telemetryType]) {
        return TelemetryTypeContentTypeMappingList[telemetryType];
    }
}

/// <summary>
/// This function gets the telemetry contentAction from the given telemetryType.
/// </summary>
/// <param name="telemetryType" type="integer">TelemetryType enum value</param>
/// <return>ContentAction enum.</return>
function getTelemetryBehavior(telemetryType) {
    if (TelemetryTypeBehaviorTypeMappingList[telemetryType]) {
        return TelemetryTypeBehaviorTypeMappingList[telemetryType];
    } else {
        return TelemetryBehaviorType.Undefined;
    }
}

/// <summary>
/// Private function for initializing mapping between telemetryType and telemetryContentType.
/// This will be removed after telemetryType deprecated.
/// </summary>
function initTelemetryTypeContentTypeMappingList() {
    TelemetryTypeContentTypeMappingList[TelemetryType.AppInstall] = TelemetryContentType.App;
    TelemetryTypeContentTypeMappingList[TelemetryType.AppLaunch] = TelemetryContentType.App;
    TelemetryTypeContentTypeMappingList[TelemetryType.SponsoredContent] = TelemetryContentType.SponsoredContent;
    TelemetryTypeContentTypeMappingList[TelemetryType.StructuredData] = TelemetryContentType.StructuredDataCard;
    TelemetryTypeContentTypeMappingList[TelemetryType.AppStore] = TelemetryContentType.AppStorePromo;
}

/// <summary>
/// Private function for initializing mapping between telemetryType and TelemetryBehaviorType.
/// This will be removed after telemetryType deprecated.
/// </summary>
function initTelemetryTypeBehaviorTypeMappingList() {
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.AppInstall] = TelemetryBehaviorType.Install;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.AppLaunch] = TelemetryBehaviorType.Launch;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Follow] = TelemetryBehaviorType.Follow;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Unfollow] = TelemetryBehaviorType.Unfollow;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Like] = TelemetryBehaviorType.Like;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Dislike] = TelemetryBehaviorType.Dislike;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Unlike] = TelemetryBehaviorType.Unlike;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Undislike] = TelemetryBehaviorType.Undislike;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Mute] = TelemetryBehaviorType.Mute;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Unmute] = TelemetryBehaviorType.Unmute;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.MuteCancel] = TelemetryBehaviorType.MuteCancel;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Manage] = TelemetryBehaviorType.Manage;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Hide] = TelemetryBehaviorType.Hide;
    TelemetryTypeBehaviorTypeMappingList[TelemetryType.Unhide] = TelemetryBehaviorType.Unhide;
}

// Init telemetryType mapping
initTelemetryTypeContentTypeMappingList();
initTelemetryTypeBehaviorTypeMappingList();